import { render, staticRenderFns } from "./PatientDisplay.vue?vue&type=template&id=6a8f369a&scoped=true"
import script from "./PatientDisplay.vue?vue&type=script&lang=js"
export * from "./PatientDisplay.vue?vue&type=script&lang=js"
import style0 from "./PatientDisplay.vue?vue&type=style&index=0&id=6a8f369a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8f369a",
  null
  
)

export default component.exports